/**
 * Snapshot por defecto de Órdenes de Trabajo y sus cotizaciones (tareas).
 *
 * La OT y su cotización (las tareas) forman una unidad: se snapshotean
 * juntas para que el escenario de prueba quede coherente tras un reset.
 * seed.ts las recarga cuando las tablas `sos` / `tareas` están vacías.
 */

import type { So, Tarea } from "@app-types/entities";
import { crearSnapshotStore } from "@/lib/snapshotDefault";
import { localDb } from "@core/data/adapters/dexie/db";

const soStore = crearSnapshotStore<So>("pmis.sosDefault");
const tareasStore = crearSnapshotStore<Tarea>("pmis.tareasDefault");

/** Snapshot de OTs para seed.ts (null si no hay). */
export const leerSosDefault = (): So[] | null => soStore.leer();

/** Snapshot de tareas/cotizaciones para seed.ts (null si no hay). */
export const leerTareasDefault = (): Tarea[] | null => tareasStore.leer();

/**
 * Congela el estado actual de OTs + cotizaciones (tareas) leyendo
 * directamente de la base Dexie. Devuelve los conteos guardados.
 */
export async function guardarSoComoDefault(): Promise<{
  sos: number;
  tareas: number;
}> {
  const sos = await localDb.sos.toArray();
  const tareas = await localDb.tareas.toArray();
  soStore.guardar(sos);
  tareasStore.guardar(tareas);
  return { sos: sos.length, tareas: tareas.length };
}

/** Elimina el snapshot de OTs + cotizaciones. */
export function borrarSoDefault(): void {
  soStore.borrar();
  tareasStore.borrar();
}

/** Indica si hay un snapshot de OTs guardado. */
export function existeSoDefault(): boolean {
  return soStore.existe();
}
